import Repository from "./Repository";

const resourceEndpoint = "/cas";

export default {
  getGarResource: () => Repository.get(`${resourceEndpoint}/`),
  getGarResourceTicket: (query) =>
    Repository.post(`${resourceEndpoint}/ticket/${query.ticket}/`),
};
